import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  buttons: {
      textAlign: "center",
      display: "flex",
      margin: "0 0 .5rem 0",
      "& button": {

          "&:first-child": {
            "flex": 1,
            "marginRight": ".5rem",
          },
      }
  },
  wrapper: {
      width: "100%",
      [theme.breakpoints.up('lg')]: {
          width: "320px",
          // padding: "1rem",

       },
  },
    modalDialog: {
      '& .MuiDialog-paper': {
          borderRadius: 10
      }
    },
    title: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 40,
        fontSize: 16,
        fontWeight: 600,
        padding: 0
    },
    closeIcon: {
        position: 'absolute',
        right: 8,
        top: 20,
    },
    content: {
        padding: '6px 40px',

        '& .MuiPaper-root.MuiPaper-elevation': {
            fontSize: 14,

        },

        '& .MuiTypography-caption': {
            opacity: .6
        },

        '& .MuiInputBase-root': {
            fontSize: 14,

            '&:active, &:hover': {
                color: theme.palette.mainButton.blue
            },

            '& .MuiAutocomplete-endAdornment': {
                right: 0
            },

            '&.MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                padding: 0,
                '& input': {
                    padding: 0,
                },
                '& svg': {
                    right: 0
                }
            },

            '& .MuiInputBase-input': {
                padding: 0,
            },

            '& fieldset': {
                border: 'none',
                borderBottom: `1px solid ${theme.palette.mainButton.dark}!important`,
                borderRadius: 0,

                '&:active, &:hover': {
                    borderBottom: `1px solid ${theme.palette.mainButton.blue}!important`,
                },

            }
        }
    },
    checkBoxControl: {
        display: 'block',
        maxHeight: 38,

        '&:active, &:hover': {
            color: theme.palette.mainButton.blue
        },

        '& .MuiButtonBase-root.Mui-checked': {
            color: theme.palette.mainButton.blue
        }
    },
    inputTypeSelect: {
      padding: 0
    },
    menuItem: {
        fontSize: 14
    },
    actions: {
      margin: '32px 0',
      justifyContent: 'center',
    },
    saveBtn: {
      width: 'calc(100% - 60px)',
      padding: '12px 0',
      backgroundColor: theme.palette.mainButton.darkBlue,
      textTransform: 'capitalize',
      fontSize: 16,
      borderRadius: 10,

        '&:active, &:hover': {
            backgroundColor: theme.palette.mainButton.blue,
        },
    },

    modalDialogDelete: {
        '& [class*=saveBtn]': {
            backgroundColor: theme.palette.mainButton.red,

            '&:active, &:hover': {
                backgroundColor: theme.palette.mainButton.semiboldButtonActivity,
            }
        }
    }

}));

export default useStyles;
